import { CourierTypeReportActionTypes } from "./actionTypes";

export interface CourierTypeReportItem {
    companyName: string;
    awbNumber: string;
    jobNumber: string | null;
    status: string;
    courierType: string;
    creationTime: string;
    deliveryScanDate: string | null;
    deliveryScanTime: string | null;
    tatDisplay: string;
}

export interface CourierTypeReportInitialState {
    loading: boolean;
    error: string;
    courierTypeReportList: {
        values: CourierTypeReportItem[];
        totalRecords: number;
    };
}

const INITIAL_STATE: CourierTypeReportInitialState = {
    loading: false,
    error: "",
    courierTypeReportList: {
        values: [],
        totalRecords: 0,
    },
};

const CourierTypeReportReducer = (state = INITIAL_STATE, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case CourierTypeReportActionTypes.GET_COURIER_TYPE_REPORT_LIST:
            return {
                ...state,
                loading: true,
                error: "",
            };

        case CourierTypeReportActionTypes.GET_COURIER_TYPE_REPORT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                courierTypeReportList: {
                    values: payload.data.items,
                    totalRecords: payload.data.totalCount,
                },
            };

        case CourierTypeReportActionTypes.GET_COURIER_TYPE_REPORT_LIST_FAIL:
            return {
                ...state,
                loading: false,
                error: payload,
            };

        default:
            return state;
    }
};

export default CourierTypeReportReducer;
